import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();
export const isAndroid = Capacitor.getPlatform() === 'android';
export const isIOS = Capacitor.getPlatform() === 'ios';
export const isWeb = !isNative;

/**
 * Returns device performance tier for adaptive game juice.
 * Mobile devices get lighter animations by default.
 */
export function getPerformanceTier(): 'high' | 'mid' | 'low' {
  if (!isNative) return 'high'; // Desktop browsers = high

  // Check device memory (if available)
  const nav = navigator as any;
  const memory = nav.deviceMemory;

  if (memory && memory <= 2) return 'low';
  if (memory && memory <= 4) return 'mid';

  // Fallback: check hardware concurrency
  const cores = navigator.hardwareConcurrency;
  if (cores && cores <= 2) return 'low';
  if (cores && cores <= 4) return 'mid';

  return 'high';
}
